import { useQuery } from "react-query";
import { getEmployeeAdOverrideGroup } from "actions/Utilities/EmployeeADOverrideGroup";

export const useGetEmployeeAdOverrideGroup = () => {
  return useQuery("GetEmployeeAdOverrideGroup", getEmployeeAdOverrideGroup, {
    refetchOnWindowFocus: false,
  });
};
